import React, { useEffect } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { useMaterielTypeModel } from "../materielTypeModel"
import { IMaterielTypeDetail, OptType } from "../materielTypeTypes"
import { globalPrompt } from "../../../../components2/YhMessage"

function containsChildByKey(node: IMaterielTypeDetail, key: React.Key): any {
    if (node.hasOwnProperty("children")) {
        for (let childNode of node.children as IMaterielTypeDetail[]) {
            if (childNode) {
                if (childNode.key === key) {
                    return node;
                }
                const ret = containsChildByKey(childNode, key);
                if (ret != null) {
                    return ret;
                }
            }
        }
    }
}

function getPNodeByKey(key: React.Key, initTreeData: IMaterielTypeDetail[]) {
    for (let node of initTreeData) {
        const pNode = containsChildByKey(node, key)
        if (pNode != null) {
            return pNode;
        }
    }
}

const MaterielTypeTree = () => {
    const { dictData, selectDictPRow, selectDictRow, selectDictRowKey, root, setOptType, setRoot, setAddTreeFrom,removeTreeForm, loadDictData, setSelectDictRowKey, setSelectDictRow, setSelectDictPRow,} = useMaterielTypeModel()
    useEffect(() => {
        loadDictData()
    }, [])
    const addPeer = () => {
        let rowCode = selectDictRow.code as string
        let rowCodeSlice = rowCode.slice(0, rowCode.length - 1)
        let pcodeLen = selectDictPRow?.children?.length as number
        if (selectDictPRow) {
            setAddTreeFrom({
                pcode: selectDictRow.pcode,
                code: rowCodeSlice + (pcodeLen + 1),
                branch:selectDictRow.branch
            })
            setRoot(true)
        } else {//当前选中为根级元素的时候，他的字典编码是可以自定义编辑的
            setRoot(false)
            setAddTreeFrom({})
        }
        setOptType(OptType.ADD_SAME_LEVEL);

    }
    const addSon = () => {
        const { children, code } = selectDictRow
        let dictRowLen = children?.length as number
        setAddTreeFrom({
            pcode: code,
            code: `${code}-0${dictRowLen >= 10 ? dictRowLen + 1 : '0' + (dictRowLen + 1)}`,
            branch:selectDictRow.branch
        })
        setRoot(true)
        setOptType(OptType.ADD_CHILD_LEVEL);
    }
    const remove = ()=>{
        if(selectDictRowKey.length==0){
            return globalPrompt("message",{type:"error",text:"请先选择要删除的值"})
        }
        removeTreeForm()
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={selectDictRowKey.length==0}
            onClick={() => addPeer()}
        >增加同级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={selectDictRowKey.length==0}
            onClick={() => addSon()}
        >增加下级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => remove()}
        >删除</Button>
    </>
    const treelist = [
        {
            id: "c888e217b1759549cfc042d12db6f9f8",
            dictCode: "001",
            dictName: "客户类型",
            dictType: null,
            dictStatus: 0,
            pcode: "",
            orderNum: 1,
            dictDesc: "客户",
            children: [
                {
                    id: "697a4a4e03d1b7aa3ea95560e6b6fc64",
                    dictCode: "001001",
                    dictName: "零销客户",
                    dictType: null,
                    dictStatus: 0,
                    pcode: "001",
                    orderNum: 1001,
                    dictDesc: "字典描述",
                    children: [],
                    key: "001001",
                    title: "零销客户",
                },
                {
                    id: "6ada82d61f17811d90584a4a503ee90c",
                    dictCode: "001002",
                    dictName: "渠道商",
                    dictType: null,
                    dictStatus: 0,
                    pcode: "001",
                    orderNum: 1002,
                    dictDesc: "字典描述",
                    children: [],
                    key: "001002",
                    title: "渠道商",
                },
                {
                    id: "43b41f1aab0379a62b938d8a48aa17c0",
                    dictCode: "001003",
                    dictName: "加盟商",
                    dictType: null,
                    dictStatus: 0,
                    pcode: "001",
                    orderNum: 1003,
                    dictDesc: "字典描述",
                    children: [{
                        id: "93f74559819ab74bc228b36bd665c0bd",
                        dictCode: "001003001",
                        dictName: "蔚县",
                        dictType: null,
                        dictStatus: 0,
                        pcode: "001003",
                        orderNum: 1003001,
                        dictDesc: "字典描述",
                        children: [],
                        key: "001003001",
                        title: "蔚县",
                    }],
                    key: "001003",
                    title: "加盟商",
                }
            ],
            key: "001",
            title: "客户类型",
        },
        {
            id: "a6f424f31a0252b79990d720c29a6447",
            dictCode: "039",
            dictName: "单据类型",
            dictType: null,
            dictStatus: 0,
            pcode: "",
            orderNum: 39,
            dictDesc: "单据备注",
            children: [{
                id: "36e62fbcf536260a890a79e6599a6d76",
                dictCode: "039001",
                dictName: "销售单",
                dictType: null,
                dictStatus: 0,
                pcode: "039",
                orderNum: 39001,
                dictDesc: "销售描述",
                children: [],
                key: "039001",
                title: "销售单",
            }],
            key: "039",
            title: "单据类型",
        }
    ]
    // const setKeyTitle = (treeLists: any) => {
    //     // treeLists.forEach((item:any,index:number)=>{
    //     //     if(item.children.length!=0){
    //     //         setKeyTitle(item.children)
    //     //     }else{
    //     //         item.children = []
    //     //     }
    //     // })
    //     treeLists.forEach((item: any, index: number) => {
    //         const itemChild:object[] = item.children
    //         if (item.children==false) {
    //             item.title = item.name;
    //             setKeyTitle(item.children)
    //         } else {
    //             item.children = [];
    //             item.title = item.name;
    //         }
    //     })
    //     console.log(treeLists)
    //     return treeLists
    // }
    const onSelect = (selectedKeys: React.Key[], info: any) => {
        const selectedNode = info.selectedNodes[0];
        const pNode = getPNodeByKey(selectedKeys[0], dictData)
        setRoot(true)
        setSelectDictPRow(pNode)
        setSelectDictRow(selectedNode)
        setSelectDictRowKey(selectedKeys)
        setOptType(OptType.DETAIL)
    }
    const onCheck = () => {

    }
    return <YhBox action={action} title="物料类型目录" width="500px">
        <Tree
            className="p-15"
            treeData={dictData}
            selectedKeys={selectDictRowKey}
            onSelect={onSelect}
            onCheck={onCheck}
        />
    </YhBox>
}
export default MaterielTypeTree